import { ReactNode } from 'react'

import { Grid } from '@/features/storefronts/_storeBase/card/v2/OfferCard/shared/ItemsGrid'
import { isLegendaryOffer, isStoreSpecial } from '@/features/storefronts/productFilters'

import { ClashOfClansItem, ClashOfClansSubItem } from './ClashOfClansItem'
import { ClashOfClansStoreSpecialHero } from './ClashOfClansStoreSpecialHero'
import { ClashOfClansStoreSpecialVideoHero } from './ClashOfClansStoreSpecialVideoHero'
import { OfferCardContentType } from '../../../shared/types'

import styles from './ClashOfClansOfferCardContent.module.scss'

const ClashOfClansSingleItemCardContent = ({ product }: OfferCardContentType): ReactNode => {
  return (
    <div className={styles.Item} key={`product-${product.id}-content`}>
      <ClashOfClansItem product={product} />
    </div>
  )
}

const ClashOfClansMultipleItemCardContent = ({ product }: OfferCardContentType): ReactNode => {
  const subItemStyle = product.contents.length > 2 ? 'SubItem' : 'SubItemLarge'
  const isStoreSpecialOffer = isStoreSpecial(product)
  const productCount = product.contents.length
  const styleMode = productCount === 4 ? 'TightGrid' : 'NormalGrid'
  const itemType = product.contents.length > 2 ? 'default' : 'large'
  return (
    <div className={styles.MultiItemContent}>
      {isStoreSpecialOffer && <ClashOfClansStoreSpecialHero product={product} />}
      <div className={styles.MultiItemGridContainer}>
        <Grid gameId={'clashofclans'} className={styles[styleMode]}>
          {product.contents.map((content, index) => (
            <div className={styles[subItemStyle]} key={`product-${product.id}-content-${index}`}>
              <ClashOfClansSubItem content={content} isStoreSpecial={isStoreSpecialOffer} type={itemType} />
            </div>
          ))}
        </Grid>
      </div>
    </div>
  )
}

const ClashOfClansMultipleItemVideoCardContent = ({ product }: OfferCardContentType): ReactNode => {
  const subItemStyle = 'SubItemLarge'
  const isStoreSpecialOffer = isStoreSpecial(product)
  const styleMode = 'NormalGrid'

  return (
    <div className={styles.MultiItemContent}>
      <ClashOfClansStoreSpecialVideoHero product={product} />
      <div className={styles.MultiItemGridContainer}>
        <Grid gameId={'clashofclans'} className={styles[styleMode]}>
          {product.contents.map((content, index) => (
            <div className={styles[subItemStyle]} key={`product-${product.id}-content-${index}`}>
              <ClashOfClansSubItem content={content} isStoreSpecial={isStoreSpecialOffer} type={'large'} />
            </div>
          ))}
        </Grid>
      </div>
    </div>
  )
}

export function ClasOfClansContent({ product, offerCardType }: OfferCardContentType): ReactNode {
  const isMultiItemOffer = product.contents.length > 1
  const isLegendaryScenery = isLegendaryOffer(product)

  if (isLegendaryScenery && offerCardType === 'special') {
    return <ClashOfClansMultipleItemVideoCardContent product={product} />
  }

  if (offerCardType === 'special' || isMultiItemOffer) {
    return <ClashOfClansMultipleItemCardContent product={product} />
  }

  return <ClashOfClansSingleItemCardContent product={product} />
}

export function ClashOfClansOfferCardContent({ product, offerCardType }: OfferCardContentType): ReactNode {
  return (
    <div className={styles.Content}>
      <ClasOfClansContent product={product} offerCardType={offerCardType} />
    </div>
  )
}
